"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get SearchServicesCsvUnion () {
        return SearchServicesCsvUnion;
    },
    get SearchServicesUnion () {
        return SearchServicesUnion;
    }
});
const _zod = require("zod");
const SearchServicesUnion = _zod.z.union([
    _zod.z.literal("employee"),
    _zod.z.literal("employee_meeting_stats"),
    _zod.z.literal("meeting"),
    _zod.z.literal("meeting_workspace"),
    _zod.z.literal("action_item"),
    _zod.z.literal("review_cycle_log"),
    _zod.z.literal("scim_log"),
    _zod.z.literal("survey")
]);
const SearchServicesCsvUnion = _zod.z.literal("employee");
